/**
 * DashboardHeader Component
 * Top navigation header with user info and actions
 * Mobile-responsive design
 */
import React from 'react';
import { FaBars, FaUserCircle, FaKey, FaSignOutAlt, FaAngleDoubleLeft } from 'react-icons/fa';
import InstallAppButton from '../shared/InstallAppButton';

const DashboardHeader = ({ 
  user, 
  sidebarOpen, 
  onToggleSidebar, 
  onChangePassword, 
  onLogout 
}) => {
  return (
    <header className="bg-gradient-to-r from-[#1A2942] to-[#1E3A5F] border-b border-[#2D5A8F] px-3 sm:px-6 py-3 sm:py-4 flex items-center justify-between">
      {/* Left side - Logo and toggle */}
      <div className="flex items-center space-x-2 sm:space-x-4">
        <button 
          onClick={onToggleSidebar}
          title={sidebarOpen ? 'Minimize sidebar (use full width)' : 'Show sidebar'}
          aria-label={sidebarOpen ? 'Minimize sidebar' : 'Show sidebar'}
          className="flex items-center gap-1.5 px-2.5 py-1.5 rounded-md bg-[#1E3A5F] hover:bg-[#FFD700] text-white hover:text-[#0A1929] transition-colors border border-[#FFD700]/30"
          data-testid="sidebar-toggle-btn"
        >
          {sidebarOpen ? (
            <>
              <FaAngleDoubleLeft size={16} />
              <span className="hidden sm:inline text-xs font-semibold">Minimize</span>
            </>
          ) : (
            <>
              <FaBars size={16} />
              <span className="hidden sm:inline text-xs font-semibold">Menu</span>
            </>
          )}
        </button>
        <div>
          <h1 className="text-lg sm:text-2xl font-bold" style={{ color: '#FFD700' }}>
            Arth Gurukul
          </h1>
        </div>
      </div>

      {/* Right side - User info and actions */}
      <div className="flex items-center space-x-2 sm:space-x-4">
        {/* Install-as-app CTA (hidden if user already runs the PWA) */}
        <InstallAppButton variant="header" label="Install App" />
        {/* User info - hidden on very small screens */}
        <div className="hidden sm:block text-right">
          <p className="text-white font-medium text-sm sm:text-base truncate max-w-[120px] sm:max-w-none">{user?.name}</p>
          <p className="text-gray-400 text-xs sm:text-sm capitalize">{user?.role?.replace('_', ' ')}</p>
        </div>
        <FaUserCircle className="text-[#FFD700] hidden xs:block" size={32} />
        <button
          onClick={onChangePassword}
          className="p-2 sm:px-3 sm:py-2 bg-[#2D5A8F] hover:bg-[#3D6A9F] text-white rounded-lg transition-colors flex items-center justify-center"
          title="Change Password"
          data-testid="header-change-password-btn"
        >
          <FaKey size={16} />
        </button>
        <button
          onClick={onLogout}
          className="p-2 sm:px-4 sm:py-2 bg-red-600 hover:bg-red-700 text-white rounded-lg transition-colors flex items-center space-x-1 sm:space-x-2"
          data-testid="logout-btn"
        >
          <FaSignOutAlt size={16} />
          <span className="hidden sm:inline">Logout</span>
        </button>
      </div>
    </header>
  );
};

export default DashboardHeader;
